module.exports = __webpack_public_path__ + "static/20230619_202-1c8a16d85cb5b71d998bc35c66ac15b0.jpg";